import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Async from 'react-code-splitting';
import classNames from 'classnames';

// eslint-disable-next-line no-unused-vars
/* globals System __webpack_public_path__ */
import * as xlActions from '../actions/xl';
import * as googleTagManager from '../utils/googleTagManager';
import Timing from '../utils/timing';
import {PATHS, pathByLabel} from '../utils/urlPaths';
import {sendToParent, TYPES} from '../../common/events';

const RecaptchaModal = props => (
  <Async
    load={System.import('./RecaptchaModal' /* webpackChunkName: "google_captcha" */)}
    componentProps={props}
  />
);

const ChineseCaptchaModal = props => (
  <Async
    load={System.import('./ChineseCaptchaModal' /* webpackChunkName: "chinese_captcha" */)}
    componentProps={props}
  />
);

const DISABLE_FIXED_HEIGHT_PATHS = [
  pathByLabel[PATHS.LOGIN_BY_SOCIALS],
  pathByLabel[PATHS.SOCIALS_LOGIN],
  pathByLabel[PATHS.CREATE_ACCOUNT]
];

class App extends Component {
  constructor(props) {
    super(props);

    // eslint-disable-next-line no-global-assign
    __webpack_public_path__ = `${props.xl.cdn}/`;

    const {
      xl,
      auth: {
        registration: {promo_email_agreement}
      }
    } = this.props;
    const socialLinks = xl.socialLinks || {};

    // Calculate wrapper height
    const data = {
      primary: {
        count: socialLinks.primary.length,
        btnHeight: 48,
        btnMargin: 15,
        blockMargin: 40
      }
    };

    const baseLineHeight = 16 /* px */ * 1.1 /* em */;

    const hasSecondarySocials = socialLinks.secondary.length > 0 || socialLinks.other.length > 0;
    const height = {
      primary: data.primary.btnHeight + data.primary.btnMargin,
      secondary: hasSecondarySocials ? 50 : 0,
      consent: 6 + 5 * baseLineHeight + 30,
      promoEmailAgreement: 6 + 2 * baseLineHeight, // 6 padding
      centralForm: 240 + 50 // 240 central form, 50 padding wrapper
    };

    if (data.primary.count) {
      height.primary =
        data.primary.count * data.primary.btnHeight +
        data.primary.blockMargin +
        (data.primary.count - 1) * data.primary.btnMargin;
    }

    const registrationAdditionalHeight =
      promo_email_agreement * height.promoEmailAgreement + height.consent;
    const authAdditionalHeight = height.primary + height.secondary;
    props.dispatch(
      xlActions.setBlockHeight(
        `${Math.max(registrationAdditionalHeight, authAdditionalHeight) + height.centralForm}px`
      )
    );
  }

  getChildContext() {
    return {
      location: this.props.location
    };
  }

  componentDidMount() {
    const {
      dispatch,
      xl: {enableAnalytics}
    } = this.props;
    // Add a class if not in the iframe

    if (window.self === window.top) {
      // noinspection Eslint
      dispatch(xlActions.notIFrame());
      document.body.className += ' with-bg';
    }

    const timing = new Timing(this.props.serverInfo);

    window.onload = () => {
      timing.sendLoadReport();
      if (enableAnalytics) {
        googleTagManager.initialization();
      }
      sendToParent(TYPES.LOADED);
    };
  }

  render() {
    const {
      xl,
      location: {pathname}
    } = this.props;
    const blur = xl.captcha.visible || xl.chineseCaptcha.visible ? 'blur' : '';

    const disallowedPathToCalc = DISABLE_FIXED_HEIGHT_PATHS.includes(pathname);

    const useFixedHeight = !xl.compactView && !disallowedPathToCalc;

    const wrapperStyle = {
      height: useFixedHeight ? xl.blockHeight : 'auto'
    };

    return (
      <div className={classNames('content', {'content--with-space': useFixedHeight})}>
        {xl.captcha.mounted && <RecaptchaModal location={this.props.location} />}
        {xl.chineseCaptcha.visible && <ChineseCaptchaModal location={this.props.location} />}
        <div
          className={classNames('wrapper', {'wrapper--small': xl.compactView}, blur)}
          style={wrapperStyle}
        >
          {this.props.children}
        </div>
      </div>
    );
  }
}

App.childContextTypes = {
  location: PropTypes.object
};

App.propTypes = {
  dispatch: PropTypes.func.isRequired,
  children: PropTypes.object,
  location: PropTypes.object.isRequired,
  serverInfo: PropTypes.object,
  xl: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired
};

export default connect(state => state)(App);



// WEBPACK FOOTER //
// ./components/App.jsx